var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 72,
    viewBox: "0 0 71 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_275)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.6129,
    y: 8.28333,
    width: 49.7,
    height: 49.7,
    rx: 24.85,
    fill: "#2775CA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.813 52.3834C46.2868 52.3834 54.713 43.9572 54.713 33.4834C54.713 23.0096 46.2868 14.5834 35.813 14.5834C25.3392 14.5834 16.913 23.0096 16.913 33.4834C16.913 43.9572 25.3392 52.3834 35.813 52.3834Z",
    fill: "#2775CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0102 36.4758C41.0102 33.7196 39.3565 32.7746 36.049 32.3809C33.6865 32.0659 33.214 31.4359 33.214 30.3333C33.214 29.2307 34.0015 28.5221 35.5765 28.5221C36.994 28.5221 37.7815 28.9946 38.1752 30.1759C38.254 30.4121 38.4903 30.5695 38.7265 30.5695H39.9864C40.3015 30.5695 40.5377 30.3333 40.5377 30.0184V29.9396C40.2226 28.207 38.8051 26.8684 36.994 26.7109V24.8209C36.994 24.5059 36.7577 24.2696 36.364 24.1908H35.1828C34.8677 24.1908 34.6315 24.427 34.5526 24.8209V26.6321C32.1901 26.9472 30.694 28.5221 30.694 30.4909C30.694 33.0897 32.269 34.1133 35.5765 34.5072C37.7815 34.9009 38.4903 35.3734 38.4903 36.6334C38.4903 37.8935 37.3876 38.7597 35.8915 38.7597C33.8439 38.7597 33.1351 37.8933 32.8989 36.712C32.8203 36.3972 32.584 36.2395 32.3478 36.2395H31.0089C30.694 36.2395 30.4578 36.4758 30.4578 36.7909V36.8697C30.7726 38.8383 32.0327 40.2558 34.6315 40.6497V42.5397C34.6315 42.8545 34.8677 43.0908 35.2614 43.1696H36.4426C36.7577 43.1696 36.994 42.9334 37.0728 42.5397V40.6497C39.4353 40.2558 41.0102 38.602 41.0102 36.4758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7968 44.7446C25.6543 42.5397 22.5042 35.6884 24.7881 29.6246C25.9694 26.3171 28.5681 23.7971 31.7968 22.6159C32.1119 22.4584 32.2693 22.2222 32.2693 21.8283V20.7259C32.2693 20.4108 32.1119 20.1746 31.7968 20.0959C31.718 20.0959 31.5606 20.0959 31.4817 20.1746C24.0006 22.5371 19.9055 30.4909 22.268 37.9721C23.6855 42.3821 27.0718 45.7684 31.4817 47.1859C31.7968 47.3433 32.1119 47.1859 32.1905 46.8708C32.2693 46.7922 32.2693 46.7134 32.2693 46.556V45.4533C32.2693 45.2171 32.0331 44.9022 31.7968 44.7446ZM40.1444 20.1746C39.8293 20.0171 39.5142 20.1746 39.4356 20.4896C39.3568 20.5684 39.3568 20.6471 39.3568 20.8047V21.9071C39.3568 22.2222 39.5931 22.5371 39.8293 22.6947C45.9718 24.8996 49.1219 31.7508 46.838 37.8147C45.6567 41.1222 43.058 43.6421 39.8293 44.8234C39.5142 44.9808 39.3568 45.2171 39.3568 45.6109V46.7134C39.3568 47.0284 39.5142 47.2647 39.8293 47.3433C39.9081 47.3433 40.0656 47.3433 40.1444 47.2647C47.6256 44.9022 51.7206 36.9483 49.3581 29.4671C47.9406 24.9784 44.4755 21.5921 40.1444 20.1746Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_275",
    x: 0.112915,
    y: 0.583325,
    width: 70.7,
    height: 70.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_275",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_275"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.913,
    y: 14.5834,
    width: 37.8,
    height: 37.8,
    rx: 18.9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdc);
export default __webpack_public_path__ + "static/media/usdc.ea63257bdfcf0b8e1ed6603bfb942a75.svg";
export { ForwardRef as ReactComponent };